import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_generic_doc_custom_processing_queue_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  filter_guid: fromDatatype.GuidDataFieldInterface;
  filter_code: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gendoc_hdr_posting_status: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_client_doc_type: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_txn_date: fromDatatype.GuidDataFieldInterface;
  gendoc_hdr_created_date: fromDatatype.GuidDataFieldInterface;
  gendoc_hdr_last_updated: fromDatatype.GuidDataFieldInterface;
  gendoc_hdr_created_by_name: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_last_updated_by_name: fromDatatype.VarcharDatatypeInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  processor_code: fromDatatype.VarcharDatatypeInterface;
  processor_name: fromDatatype.VarcharDatatypeInterface;
  trigger_type: fromDatatype.VarcharDatatypeInterface;
  external_process_start_date: fromDatatype.TimestampTzDatatypeInterface;
  external_process_end_date: fromDatatype.TimestampTzDatatypeInterface;
  external_process_status: fromDatatype.VarcharDatatypeInterface;
  external_process_error: fromDatatype.VarcharDatatypeInterface;
  external_response_status: fromDatatype.VarcharDatatypeInterface;
  external_document_type: fromDatatype.VarcharDatatypeInterface;
  external_document_code: fromDatatype.VarcharDatatypeInterface;
  external_submission_no: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}

export class bl_fi_generic_doc_custom_processing_queue_RowClass implements bl_fi_generic_doc_custom_processing_queue_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  filter_guid: fromDatatype.GuidDataFieldInterface;
  filter_code: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gendoc_hdr_posting_status: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_client_doc_type: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_txn_date: fromDatatype.GuidDataFieldInterface;
  gendoc_hdr_created_date: fromDatatype.GuidDataFieldInterface;
  gendoc_hdr_last_updated: fromDatatype.GuidDataFieldInterface;
  gendoc_hdr_created_by_name: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_last_updated_by_name: fromDatatype.VarcharDatatypeInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  processor_code: fromDatatype.VarcharDatatypeInterface;
  processor_name: fromDatatype.VarcharDatatypeInterface;
  trigger_type: fromDatatype.VarcharDatatypeInterface;
  external_process_start_date: fromDatatype.TimestampTzDatatypeInterface;
  external_process_end_date: fromDatatype.TimestampTzDatatypeInterface;
  external_process_status: fromDatatype.VarcharDatatypeInterface;
  external_process_error: fromDatatype.VarcharDatatypeInterface;
  external_response_status: fromDatatype.VarcharDatatypeInterface;
  external_document_type: fromDatatype.VarcharDatatypeInterface;
  external_document_code: fromDatatype.VarcharDatatypeInterface;
  external_submission_no: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}